import { connect } from 'react-redux';
import { VirtualBrand } from '~/Api/Analytics/VirtualBrand';
import { Registration } from '~/Api/Analytics/VirtualBrand/Registration';
import { formatNumericHumanDate } from '~/DateTime';
import {
	loadRegistration,
	selectRegistrationById,
	State as RegistrationState,
} from '~/MedicinalBrandsAnalytics/VirtualBrand/Registration';

import RegistrationTab from './RegistrationTab';

interface State {
	medicinalBrandsAnalyticsRegistration: RegistrationState;
}

interface OwnProps {
	virtualBrand: VirtualBrand;
}

function mapStateToProps(
	{ medicinalBrandsAnalyticsRegistration }: State,
	{ virtualBrand }: OwnProps
): { registration: Registration | null; isFetching: boolean; formatDate: typeof formatNumericHumanDate } {
	const registrationState = selectRegistrationById(medicinalBrandsAnalyticsRegistration, virtualBrand.id);
	return {
		isFetching: Boolean(registrationState?.isFething),
		registration: registrationState?.registration || null,
		formatDate: formatNumericHumanDate,
	};
}

const actions = {
	onLoad: loadRegistration,
};

export default connect(mapStateToProps, actions)(RegistrationTab);
